"use strict";
const MAX_NUMBER_OF_TOUCHPOINT_SCRIPTS_ALLOWED_FREE_USER = 3;
module.exports = {
    MAX_NUMBER_OF_TOUCHPOINT_SCRIPTS_ALLOWED_FREE_USER,
};
//# sourceMappingURL=consts.js.map